import { get } from 'lodash';

const ensureApplicationStatusMessages = (messages, localePrefix, applicationStatus, keys) => {
    let appStatus = applicationStatus;
    // if we are missing a key for this application status, then use "unknownDecision"
    keys.forEach(key => {
        if (!get(messages, `${localePrefix}.${applicationStatus}.${key}`)) {
            appStatus = 'unknownDecision';
        }
    });
    return appStatus;
};

export default ensureApplicationStatusMessages;
